export default __webpack_public_path__ + "static/media/doordash.3e1ab9e1.png";